import { Box } from '@mui/material'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { useAuth } from 'contexts/auth'
import { useState } from 'react'
import {
  finalizedCards,
  finalizedCardsBuyer,
  initializedCards,
  initializedCardsBuyer,
  toDoCards,
  toDoCardsBuyer,
} from './contants'
import KanbanCard from './kanban-card'
import KanbanColumn from './kanban-column'
import KanbanStatus from './kanban-status'
import { useStyles } from './styles'

type TFamilyName = 'movimentation' | 'implantation'

interface IFilter {
  organizations: string
  families: string
}

const ControlPannel = () => {
  const [filter, setFilter] = useState<IFilter>({
    organizations: 'Todos',
    families: 'Todos',
  })

  const { user } = useAuth()

  const classes = useStyles()

  const handleClearFilter = () =>
    setFilter({
      families: 'Todos',
      organizations: 'Todos',
    })

  if (!user) {
    return null
  }

  const data = {
    toDoCount: user.isSeller ? Number(toDoCards.length) : Number(toDoCardsBuyer.length),
    initializedCount: user.isSeller ? Number(initializedCards.length) : Number(initializedCardsBuyer.length),
    finalizedCount: user.isSeller ? Number(finalizedCards.length) : Number(finalizedCardsBuyer.length),
    toDoCardList: user.isSeller ? toDoCards : toDoCardsBuyer,
    initializedCardList: user.isSeller ? initializedCards : initializedCardsBuyer,
    finalizedCardList: user.isSeller ? finalizedCards : finalizedCardsBuyer,
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title text='Tarefas' />
        {/* <ControlPannelFilter
          filter={filter}
          onChangeFilter={setFilter}
          onClear={handleClearFilter}
        /> */}
      </Header>

      <Page>
        <Box className={classes.columnsContainer}>
          <KanbanColumn status='toDo'>
            <KanbanStatus
              status='toDo'
              stage='A fazer'
              counter={data.toDoCount}
            />
            <div className={classes.cardsContainer}>
              {data.toDoCardList.map((todo, key) => (
                <KanbanCard
                  key={key}
                  healthPlanName={todo.name}
                  isHealthPlan={todo.healthPlan}
                  date={todo.date}
                  clientName={todo.clientName}
                  familyName={todo.familyName as TFamilyName}
                  isFinalized={false}
                />
              ))}
            </div>
          </KanbanColumn>
          <KanbanColumn status='initialized'>
            <KanbanStatus
              status='initialized'
              stage='Iniciado'
              counter={data.initializedCount}
            />
            <div className={classes.cardsContainer}>
              {data.initializedCardList.map((initialized, key) => (
                <KanbanCard
                  key={key}
                  healthPlanName={initialized.name}
                  isHealthPlan={initialized.healthPlan}
                  date={initialized.date}
                  clientName={initialized.clientName}
                  familyName={initialized.familyName as TFamilyName}
                  isFinalized={false}
                />
              ))}
            </div>
          </KanbanColumn>
          <KanbanColumn status='completed'>
            <KanbanStatus
              status='completed'
              stage='Concluído'
              counter={data.finalizedCount}
            />
            <div className={classes.cardsContainer}>
              {data.finalizedCardList.map((finalized, key) => (
                <KanbanCard
                  key={key}
                  healthPlanName={finalized.name}
                  isHealthPlan={finalized.healthPlan}
                  date={finalized.date}
                  clientName={finalized.clientName}
                  familyName={finalized.familyName as TFamilyName}
                  isFinalized={true}
                />
              ))}
            </div>
          </KanbanColumn>
        </Box>
      </Page>
    </Wrapper>
  )
}

export default ControlPannel
